import { render, staticRenderFns } from "./LayoutModal.vue?vue&type=template&id=1a37172f&"
import script from "./LayoutModal.vue?vue&type=script&lang=js&"
export * from "./LayoutModal.vue?vue&type=script&lang=js&"
import style0 from "./LayoutModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports